import React from "react";

import Shimmer from "./Shimmer";

export const ParagraphShimmer = () => (
  <>
    <Shimmer />
    <Shimmer />
    <Shimmer width="80%" />
  </>
);
